import {
  Badge,
  Box,
  ClickAwayListener,
  Divider,
  Grow,
  Popper,
  Typography,
  IconButton,
  Skeleton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
} from '@common/components'
import { Paper } from './notifications.styles'
import { useTogglePopover, useTranslation } from '@common/hooks'
import { LinkIcon, NotificationsIcon } from '@common/icons'
import {
  useNotificationGetNotificationsQuery,
  useNotificationGetUnreadNotificationsNumberQuery,
} from '@app/services/auto-generated/notification'
import { RouterLink } from '@lib/router'
import React from 'react'

const Notifications = () => {
  const { open, anchorEl, handleClose, handleOpen } = useTogglePopover()
  const { data: unreadNotif } = useNotificationGetUnreadNotificationsNumberQuery({}, { skip: open })

  return (
    <>
      <IconButton
        color='neutral'
        onClick={(event) => {
          handleOpen(event)
        }}
      >
        <Badge color='primary' badgeContent={unreadNotif?.number} invisible={open}>
          <NotificationsIcon className='custom-menu-icon' />
        </Badge>
      </IconButton>
      {open ? (
        <PopperNotification open={open} anchorEl={anchorEl} handleClose={handleClose} />
      ) : null}
    </>
  )
}

const PopperNotification = (props) => {
  const { open, anchorEl, handleClose } = props
  const {
    data: notifications,
    isSuccess,
    isLoading,
  } = useNotificationGetNotificationsQuery({ limit: 100 })
  const { t } = useTranslation()
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      role={undefined}
      placement='bottom-end'
      transition
      // disablePortal
      sx={{ zIndex: 2000 }}
      modifiers={[
        {
          name: 'flip',
          enabled: false,
        },
        {
          name: 'offset',
          options: {
            offset: [-20, 5],
          },
        },
      ]}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: 'center top',
          }}
        >
          <Paper sx={{ p: 0 }}>
            <ClickAwayListener onClickAway={handleClose}>
              <Box>
                <Typography variant='body1' align='center' sx={{ px: 4, py: 1 }}>
                  {t('notifications.notifications', 'Notifications')}
                </Typography>
                <Divider />
                <Box sx={{ width: '350px', maxWidth: '90vw' }}>
                  {isLoading ? (
                    <Stack spacing={1} sx={{ p: 1 }}>
                      <Skeleton variant='rectangular' />
                      <Skeleton variant='rectangular' />
                      <Skeleton variant='rectangular' />
                      <Skeleton variant='rectangular' />
                    </Stack>
                  ) : isSuccess ? (
                    notifications.length === 0 ? (
                      <Box sx={{ p: 1 }}>
                        <Typography color='grey' variant='body2'>
                          {t('notifications.noNotifications', 'No notifications yet')}
                        </Typography>
                      </Box>
                    ) : (
                      <List sx={{ mt: 1, maxHeight: '350px', overflow: 'auto' }}>
                        {[...notifications]
                          ?.sort((a, b) => new Date(a.is_read_at) - new Date(b.is_read_at))
                          .map((notif, index) => (
                            <Notification
                              key={index}
                              title={notif.message_title}
                              text={notif.message_body_text}
                              link={notif.message_body_link}
                            />
                          ))}
                      </List>
                    )
                  ) : null}
                </Box>
              </Box>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}
const Notification = (props) => {
  const { title, text, link } = props
  return (
    <ListItem disablePadding>
      <ControlledNotif sx={{ py: 0 }} link={link && `/dashboard${link}`}>
        <ListItemText
          primary={title}
          secondary={
            <Box component='span' display='flex' alignItems='center' justifyContent='space-between'>
              <Typography
                sx={{ display: 'inline' }}
                component='span'
                variant='body2'
                color='text.primary'
              >
                {text}
              </Typography>
              {link && <LinkIcon sx={{ transform: 'rotate(-45deg)' }} />}
            </Box>
          }
        />
      </ControlledNotif>
    </ListItem>
  )
}

const ControlledNotif = (props) => {
  const { link, children, ...restProps } = props
  if (!link) return <ListItemButton {...restProps}>{children}</ListItemButton>
  else
    return (
      <ListItemButton component={RouterLink} to={link} {...restProps}>
        {children}
      </ListItemButton>
    )
}
export default Notifications
